module.exports = __webpack_public_path__ + "static/img/ad1.844ef1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad1.png
// module id = IDtu
// module chunks = 12